import { render } from "./ItemDocumentField.vue?vue&type=template&id=33d557cc"
import script from "./ItemDocumentField.vue?vue&type=script&lang=js"
export * from "./ItemDocumentField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__